var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"4194.352 1931.352 13.606 13.606"}},[_c('g',{attrs:{"data-name":"Groupe 264"}},[_c('path',{attrs:{"d":"M4194.406 1937.79v.658h13.762v-.657z"}}),_c('path',{attrs:{"d":"M4200.953 1931.335v13.568h.667v-13.568z"}})])])};var toString = function () {return "/builds/agoulay/GUI-drivers/src/assets/svg/icon-plus.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-plus.svg
// module id = fgOk
// module chunks = 2